import {fetch} from "../../../utils/dataAccess";

export function getPickingMissionModels(currentInventory) {
    return new Promise((resolve, reject) => {
        fetch("/w_m_s_picking_mission_models/selfAffectation?inventoryId=" + currentInventory.id)
            .then(response => {
                response.json().then(retrieved => {
                    resolve(retrieved)
                })
            })
            .catch(error => reject(error));
    });
}
